var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "akl" },
    [
      _c("div", { staticClass: "bod-view-txt" }, [
        _c(
          "div",
          { staticClass: "os_noticeRes" },
          [
            _c(
              "div",
              { staticClass: "widM padTM cont_Wrap" },
              [
                _c("SurveyHeader"),
                _vm._v(" "),
                _c("SurveyParticipantInfo"),
                _vm._v(" "),
                _vm.existAttendant ? _c("SurveyConsent") : _vm._e(),
                _vm._v(" "),
                _vm.existAttendant ? _c("SurveyActivityList") : _vm._e(),
                _vm._v(" "),
                _c("hr", {
                  staticStyle: {
                    "border-top": "1px solid #ddd",
                    background: "#f4f4f4"
                  }
                }),
                _vm._v(" "),
                _vm.mode === "E" || _vm.existAttendant
                  ? _c("div", { staticClass: "widM txtC marTML" }, [
                      _c(
                        "button",
                        {
                          staticClass: "bt-akl-blue large NCACroa_submit",
                          on: { click: _vm.submitSurvey }
                        },
                        [_vm._v(_vm._s(_vm.submitBtnText))]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "padM disIb" })
              ],
              1
            ),
            _vm._v(" "),
            _vm.survey_popup ? _c("SurveyPopupLayer") : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.survey_loading ? _c("SurveyLoading") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d603ca5", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d603ca5","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/survey/Survey.vue
// module id = null
// module chunks = 